import React, { useEffect, useState } from "react";
import { Profile, Sport, Ratings } from "../../types";
import { updateProfile, flash, flashError, getPlayerProfile } from "../../actions";
import AccountForm from "../../components/settings/accountForm";
import { _ } from "libs";
import Loader from "../../components/loader";
import withRedux from "../../withRedux";
import { RootState } from "../../reducers";

type Props = {
	profile: Profile;
	updateProfile: typeof updateProfile;
	sports: Sport[];
	ratings: Ratings;
};

function getAccountErrorMessage(code: string): string {
	switch (code) {
		case "0_003_00019":
			return _("form.message.error.mobilePhoneInUse");
		case "0_003_00020":
			return _("form.message.error.emailAddressInUse");
		case "0_003_00021":
			return _("form.message.error.usernameInUse");
		default:
			return _("form.message.error");
	}
}

const Account = ({ profile, updateProfile }: Props) => {
	const onChange = async (values) => {
		try {
			await updateProfile(values);
			flash(_("form.message.saved"));
		} catch (err) {
			flashError(getAccountErrorMessage(err.response.data.responseCode));
		}
	};

	const [userProfile, setProfile] = useState(null);

	useEffect(() => {
		//force refreshing the profile
		if (!userProfile) {
			getPlayerProfile(profile.userId).then((p) => setProfile(p));
		}
	});

	return <div>{userProfile ? <AccountForm profile={userProfile} onChange={onChange} /> : <Loader />}</div>;
};

export default withRedux({ updateProfile }, ({ profile }: RootState) => {
	return { profile };
})(Account);
